import config from './config.yaml';

$(document).ready(function () {
	if (config.fixedMenu) {
		const $menu = $('.nav--top');
		const menuTop = $menu.offset().top;
		var currentPosition = $menu.css('position');

		$(window).scroll(function () {
			if ($(window).scrollTop() > menuTop && currentPosition != 'fixed') {
				const menuLeft = $menu.offset().left;
				currentPosition = 'fixed';

				$menu.css({
					position: 'fixed',
					top: '0',
					left: menuLeft,
					margin: '0'
				});
			} else if ($(window).scrollTop() <= menuTop && currentPosition == 'fixed') {
				currentPosition = 'default';

				$menu.css({
					position: '',
					top: '',
					left: '',
					margin: ''
				});
			}
		});
	}
});



// WEBPACK FOOTER //
// ./temp/components/menu/index.js